import { isNullOrWhiteSpace } from "../utils/reportHelpers";

export const computePhotoPageCount = (
  originalDoor,
  physicalList,
  complianceList,
  additionalPhotos,
) => {
  const originalImagePaths = originalDoor?.imagePaths ?? [];
  let tempPhotoCount = (originalImagePaths || []).filter(
    (p) => p && p.trim(),
  ).length;

  physicalList?.forEach((measurement) => {
    const photoGroups = [
      measurement?.head?.photos,
      measurement?.hinge?.photos,
      measurement?.closing?.photos,
      measurement?.threshold?.photos,
      measurement?.noOfHinges?.photos,
      measurement?.leftHead?.photos,
      measurement?.rightHead?.photos,
      measurement?.leftHinge?.photos,
      measurement?.rightHinge?.photos,
      measurement?.leftThreshold?.photos,
      measurement?.rightThreshold?.photos,
    ];
    photoGroups.forEach((group) => {
      tempPhotoCount += (group || []).filter((p) => p && p.trim()).length;
    });

    const customJson = measurement?.customComplianceActionJson;
    if (!isNullOrWhiteSpace(customJson)) {
      try {
        const jsonString = customJson.trim();
        if (
          !isNullOrWhiteSpace(jsonString) &&
          jsonString !== "[]" &&
          jsonString !== "null" &&
          jsonString.startsWith("[")
        ) {
          const customAction = JSON.parse(jsonString);
          if (Array.isArray(customAction) && customAction.length > 0) {
            customAction.forEach((customActionElement) => {
              try {
                tempPhotoCount += (
                  customActionElement?.Photos || []
                ).filter((p) => p && p.trim()).length;
              } catch {
                /* skip */
              }
            });
          }
        }
      } catch {
        /* skip */
      }
    }
  });

  const addPhotos = additionalPhotos?.imageUrls ?? [];
  tempPhotoCount += (addPhotos || []).filter((p) => p && p.trim()).length;

  complianceList?.forEach((comp) => {
    const compPhotos = comp?.photos ?? [];
    tempPhotoCount += (compPhotos || []).filter((p) => p && p.trim()).length;
  });

  const photosPerPage = 6;
  return Math.ceil(tempPhotoCount / photosPerPage);
};

export const computeShowCompliancePage = (
  door,
  complianceList,
  physicalList,
) => {
  const doorGlazeValue = (door?.doorGlaze ?? "").trim();
  const hasGlazing = !(doorGlazeValue.toLowerCase() === "no");
  const skipPhrases = [
    "Is there a hold open device?",
    "Is certification visible on fire door?",
    "Does the door contain glazing?",
    "Self closing device?",
  ];
  const hideWhenNonCompliant = [
    "Any Visual defects on the door?",
    "Any damage to the door?",
    "Does the door fit correctly within the frame?",
    "Any damage to the frame?",
  ];
  const showWhenCompliant = [
    "Any visual defects on the door?",
    "Any damage to the door?",
    "Any damage to the frame?",
  ];

  const keep = (c) => {
    if (c == null) return false;
    const name = (c.checkListName ?? "").trim();
    if (skipPhrases.includes(name)) return false;
    if (
      !hasGlazing &&
      name.toLowerCase().includes("is glazing pyro glazing?")
    )
      return false;
    if (
      hideWhenNonCompliant.includes(name) &&
      !c.isCompliant &&
      isNullOrWhiteSpace(c.severity)
    )
      return false;
    if (
      isNullOrWhiteSpace(c.severity) &&
      isNullOrWhiteSpace(c.remediation) &&
      isNullOrWhiteSpace(c.comment)
    )
      return false;
    if (showWhenCompliant.includes(name)) return true;
    if (c.isCompliant) return false;
    return true;
  };

  const hasRenderableCompliance = complianceList?.some(keep) ?? false;
  const hasYes = (m) =>
    m != null && (m.actionItem ?? "").trim().toLowerCase() === "yes";

  const hasRenderablePhysical =
    physicalList?.some(
      (p) =>
        hasYes(p.head) ||
        hasYes(p.hinge) ||
        hasYes(p.closing) ||
        hasYes(p.threshold) ||
        hasYes(p.noOfHinges) ||
        hasYes(p.leftHead) ||
        hasYes(p.rightHead) ||
        hasYes(p.leftHinge) ||
        hasYes(p.rightHinge) ||
        hasYes(p.leftThreshold) ||
        hasYes(p.rightThreshold),
    ) ?? false;

  let hasRenderableCustomActions = false;
  for (const pm of physicalList ?? []) {
    if (pm == null || isNullOrWhiteSpace(pm.customComplianceActionJson))
      continue;
    const json = pm.customComplianceActionJson.trim();
    if (json === "[]" || json === "null") continue;
    try {
      const parsed = JSON.parse(json);
      if (!Array.isArray(parsed)) continue;
      for (const el of parsed) {
        const actionItem = el?.actionItem ?? el?.ActionItem ?? "";
        const remediation = el?.remediation ?? el?.Remediation ?? "";
        const comment = el?.comment ?? el?.Comment ?? "";
        if (
          actionItem.trim().toLowerCase() === "yes" &&
          (!isNullOrWhiteSpace(remediation) || !isNullOrWhiteSpace(comment))
        ) {
          hasRenderableCustomActions = true;
          break;
        }
      }
    } catch {
      /* skip */
    }
    if (hasRenderableCustomActions) break;
  }

  return (
    hasRenderableCompliance ||
    hasRenderableCustomActions ||
    hasRenderablePhysical
  );
};
